import DatePicker from './Styles';

export default DatePicker;
